// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__11S4p","footer":"ModalError_footer__3nV6K"};